<template>
  <div>
    <div class="row mb-3 text-primary">
      <div class="col">
        <h5>Select by session:</h5>
      </div>
    </div>
    <div class="row row-cols-1 row-cols-md-2 g-4 h-100 mt-3">
      <div class="col" v-for="sessionItem in sessionlist">
        <button class="btn w-100 h-100 d-inline-flex position-relative" data-bs-dismiss="offcanvas" v-on:click="selectSession(sessionItem.id)"
                v-bind:class="sessionItem.id === selectedSession ?'btn-success' : 'btn-outline-primary'"
        >
          <icon :icon="['fad', 'podium']" class="fa-3x" v-if="sessionItem.title.includes('Oral')"/>
          <icon :icon="['fad', 'person-chalkboard']" class="fa-3x" v-else-if="sessionItem.title.includes('ePosters')"/>
          <span class="my-auto ms-3">
          {{ sessionItem.title }}</span>
          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
            {{ sessionItem.poster_count}}
          <span class="visually-hidden">uploaded poster</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "GroupSelectionSessions",
  data: function () {
    return {}
  },
  computed: {
    ...mapState(['themes', 'selectedType']),
    ...mapState('session', ['selectedSession', 'sessionlist']),
    selectedSessionComp: {
      get() {
        return this.selectedSession
      },
      set(id) {
        this.setSelectedSession(id);
      }
    },
    selectedTypeComp: {
      get() {
        return this.selectedType
      },
      set(id) {
        this.setSelectedType(id);
      }
    }
  },
  methods: {
    ...mapMutations(['setSelectedView', 'setSelectedType']),
    ...mapMutations('session', ['setSelectedSession']),
    selectSession(session_id) {
      this.setSelectedView('session');
      this.$store.dispatch('TRACK_ACTION', {
        'value': session_id,
        'action': 'view/session',
        'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
      });
      this.selectedSessionComp = session_id;
      this.$emit('push');
    }
  }
}
</script>

<style scoped>

</style>
